import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "@/lib/LanguageContext";
import { PRODUCT_HERO_IMAGE } from "@/lib/config";

export default function LanguageGate() {
    const { chosen, setLang, ready, t } = useLang();
    const show = ready && !chosen;

    const pick = (code) => setLang(code);

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5 }}
                    className="fixed inset-0 z-[80] bg-[#F9F6F0] flex items-center justify-center px-6"
                    data-testid="language-gate"
                    role="dialog"
                    aria-modal="true"
                >
                    <div className="absolute inset-0 opacity-10 pointer-events-none flex items-center justify-center">
                        <img
                            src={PRODUCT_HERO_IMAGE}
                            alt=""
                            aria-hidden
                            className="max-w-[520px] w-full object-contain"
                        />
                    </div>

                    <motion.div
                        initial={{ y: 24, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.7, ease: [0.19, 1, 0.22, 1] }}
                        className="relative z-10 w-full max-w-2xl text-center"
                    >
                        <div
                            className="font-serif text-2xl md:text-3xl tracking-tight text-[#2D2824] mb-8"
                            data-testid="lang-gate-brand"
                        >
                            VARDHAN
                            <sup className="text-[10px] ml-0.5 text-[#B48F57]">™</sup>
                        </div>
                        <div className="chapter-num mb-4">— Welcome · स्वागत है</div>
                        <h2 className="font-serif text-4xl md:text-6xl text-[#2D2824] tracking-[-0.02em] leading-[1.02]">
                            Choose your language.
                            <br />
                            <em className="italic text-[#B48F57]">अपनी भाषा चुनें।</em>
                        </h2>
                        <p className="mt-6 text-[14px] md:text-[15px] text-[#5C564D] leading-relaxed font-light max-w-[46ch] mx-auto">
                            You can change this any time from the top of the page.
                            <br />
                            आप इसे कभी भी बदल सकते हैं।
                        </p>

                        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-lg mx-auto">
                            <button
                                onClick={() => pick("en")}
                                className="group p-6 md:p-8 border border-[#2D2824] text-left hover:bg-[#2D2824] hover:text-[#F9F6F0] transition-colors"
                                data-testid="lang-gate-en"
                            >
                                <div className="eyebrow text-[#B48F57] mb-3">EN</div>
                                <div className="font-serif text-3xl md:text-4xl text-[#2D2824] group-hover:text-[#F9F6F0] transition-colors">
                                    English
                                </div>
                                <div className="mt-2 text-[12px] tracking-[0.14em] uppercase text-[#8A837A] group-hover:text-[#D9D1C7]">
                                    Continue →
                                </div>
                            </button>
                            <button
                                onClick={() => pick("hi")}
                                className="group p-6 md:p-8 border border-[#2D2824] text-left hover:bg-[#2D2824] hover:text-[#F9F6F0] transition-colors"
                                data-testid="lang-gate-hi"
                            >
                                <div className="eyebrow text-[#B48F57] mb-3">HI</div>
                                <div className="font-serif text-3xl md:text-4xl text-[#2D2824] group-hover:text-[#F9F6F0] transition-colors">
                                    हिन्दी
                                </div>
                                <div className="mt-2 text-[12px] tracking-[0.14em] uppercase text-[#8A837A] group-hover:text-[#D9D1C7]">
                                    आगे बढ़ें →
                                </div>
                            </button>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
